import type { AppDispatch } from "store";
import {
  createPayGCCPayment,
  PayGCCRequestPayload,
  fetchOrderHistory,
  OrderHistoryRequestPayload,
} from "services/paygccService";
import {
  setPayGCCLoader,
  payGCCSuccess,
  payGCCSuccessMsg,
  payGCCErrorMsg,
  setOrderHistoryLoading,
  setOrderHistoryData,
  setOrderHistoryError,
} from "./reducer";

export const createPayGCCPaymentThunk = (payload: PayGCCRequestPayload) => async (dispatch: any) => {
  try {
    dispatch(setPayGCCLoader(true));
    dispatch(payGCCErrorMsg({ message: "" }));

    const response = await createPayGCCPayment(payload);

    if (response.success) {
      dispatch(payGCCSuccess(response.data));
      dispatch(
        payGCCSuccessMsg({
          message: response.message || "Payment URL created successfully",
          id: response.data.paymentno || "",
        })
      );
      return { success: true, data: response.data };
    } else {
      const errorMessage = response.message || "Failed to create payment URL";
      dispatch(payGCCErrorMsg({ message: errorMessage }));
      return { success: false, message: errorMessage };
    }
  } catch (error: any) {
    console.log("=== PAY GCC THUNK ERROR ===");
    console.log("Error Object:", error);
    console.log("Error Response Data:", error?.response?.data);
    console.log("Error Message:", error?.message);
    console.log("=======================================");

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to create payment URL. Please try again.";
    dispatch(payGCCErrorMsg({ message: errorMessage }));
    return { success: false, message: errorMessage };
  }
};

export const fetchOrderHistoryThunk =
  (payload: OrderHistoryRequestPayload) => async (dispatch: AppDispatch) => {
    dispatch(setOrderHistoryLoading(true));
    dispatch(setOrderHistoryError(null));
    try {
      console.log("=== ORDER HISTORY THUNK ===");
      console.log("Request Payload:", JSON.stringify(payload, null, 2));
      
      const response = await fetchOrderHistory(payload);
      
      console.log("=== ORDER HISTORY API RESPONSE ===");
      console.log("Response:", JSON.stringify(response, null, 2));
      console.log("Success:", response.success);
      console.log("Has Data:", !!response.data);
      console.log("Order History Array:", response.data?.orderhistory);
      console.log("Order History Length:", response.data?.orderhistory?.length);
      console.log("=====================================");

      if (response.success && response.data) {
        const orderHistoryArray = response.data.orderhistory || [];
        const pagination = response.data.pagination || {
          page: payload.page || 1,
          per_page: payload.per_page || 10,
          total_pages: Math.ceil((orderHistoryArray.length || 0) / (payload.per_page || 10)),
          total_items: orderHistoryArray.length || 0,
        };
        
        console.log("Dispatching order history data:", {
          orderHistoryCount: orderHistoryArray.length,
          pagination,
        });
        
        dispatch(
          setOrderHistoryData({
            orderHistory: Array.isArray(orderHistoryArray) ? orderHistoryArray : [],
            pagination: pagination,
          })
        );
      } else {
        const errorMsg = response.message || "Failed to fetch order history";
        console.error("Order history fetch failed:", errorMsg);
        dispatch(setOrderHistoryError(errorMsg));
      }
    } catch (error: unknown) {
      console.error("=== ORDER HISTORY THUNK ERROR ===");
      console.error("Error Object:", error);
      console.error("Error Type:", typeof error);
      
      let errorMessage = "Failed to fetch order history. Please try again.";
      
      if (error && typeof error === "object") {
        const errorObj = error as any;
        if (errorObj.message) {
          errorMessage = errorObj.message;
        } else if (errorObj.response?.data?.message) {
          errorMessage = errorObj.response.data.message;
        } else if (errorObj.response?.data) {
          errorMessage = typeof errorObj.response.data === "string" 
            ? errorObj.response.data 
            : JSON.stringify(errorObj.response.data);
        } else if (typeof errorObj === "string") {
          errorMessage = errorObj;
        }
      }
      
      console.error("Final Error Message:", errorMessage);
      console.error("===================================");
      
      dispatch(setOrderHistoryError(errorMessage));
    } finally {
      dispatch(setOrderHistoryLoading(false));
    }
  };

